import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import promise from 'es6-promise'

// 解决IE不兼容ES6语法问题
promise.polyfill()
Vue.use(Vuex)

import dropDown from './modules/dropDown'
import user from './modules/user'
import globalConfig from './modules/globalConfig'
import permission from './modules/permission'
//import systemSetting from './modules/systemSetting'

const store = new Vuex.Store({
  modules: {
    user,
    dropDown,
    globalConfig,
    permission,
    //systemSetting
  }
})

export default store



// WEBPACK FOOTER //
// ./src/js/store/store.js